module.exports = __webpack_public_path__ + "static/img/stone.6f5ea65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/child/stone.png
// module id = 5PHy
// module chunks = 26